var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _circle, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNothingStaked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 159,
    viewBox: "0 0 155 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.6454 58.9737V28.9814L53.8591 17.7346H117.405L128.619 28.9814V58.9737L117.405 70.2205H53.8591L42.6454 58.9737Z",
    fill: "#6AEDC6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.99 21.4834V28.9814H123.383C120.281 28.9814 117.776 26.4698 117.776 23.3583V17.7346H125.252C127.308 17.7346 128.99 19.4219 128.99 21.4834Z",
    fill: "#4FD0A8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.99 59.2391V66.7372C128.99 68.7993 127.308 70.4865 125.252 70.4865H117.776V64.8628C117.776 61.7513 120.281 59.2391 123.383 59.2391H128.99Z",
    fill: "#4FD0A8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.6584 57.3782C92.8844 57.3782 98.7416 51.5031 98.7416 44.2564C98.7416 37.0097 92.8844 31.1352 85.6584 31.1352C78.433 31.1352 72.5758 37.0097 72.5758 44.2564C72.5758 51.5031 78.433 57.3782 85.6584 57.3782Z",
    fill: "#4FD0A8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.7962 50.0404C60.8924 50.0404 63.4027 47.522 63.4027 44.4166C63.4027 41.3106 60.8924 38.7929 57.7962 38.7929C54.6993 38.7929 52.189 41.3106 52.189 44.4166C52.189 47.522 54.6993 50.0404 57.7962 50.0404Z",
    fill: "#4FD0A8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.839 50.0404C116.936 50.0404 119.446 47.522 119.446 44.4166C119.446 41.3106 116.936 38.7929 113.839 38.7929C110.742 38.7929 108.232 41.3106 108.232 44.4166C108.232 47.522 110.742 50.0404 113.839 50.0404Z",
    fill: "#4FD0A8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.8591 17.7346V23.3583C53.8591 26.4698 51.3549 28.9814 48.2526 28.9814H42.6454V21.4834C42.6454 19.4219 44.3277 17.7346 46.3831 17.7346H53.8591Z",
    fill: "#4FD0A8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.8591 64.8628V70.4865H46.3831C44.3277 70.4865 42.6454 68.7993 42.6454 66.7372V59.2391H48.2526C51.3549 59.2391 53.8591 61.7513 53.8591 64.8628Z",
    fill: "#4FD0A8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2311 66.2168C29.2311 63.8538 31.1438 61.936 33.4993 61.936H134.107C136.462 61.936 138.375 63.8538 138.375 66.2168V139.601C138.375 141.964 136.462 143.882 134.107 143.882H33.4993C31.1438 143.882 29.2311 141.964 29.2311 139.601V66.2168Z",
    fill: "#465469"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.506 89.558H138.908C141.056 89.558 142.8 91.3064 142.8 93.4608V112.974C142.8 115.129 141.056 116.877 138.908 116.877H117.506C109.99 116.877 103.886 110.756 103.886 103.218C103.886 95.6795 109.99 89.558 117.506 89.558Z",
    fill: "#1A2639"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.362 108.927C120.586 108.927 123.199 106.306 123.199 103.073C123.199 99.8398 120.586 97.2187 117.362 97.2187C114.138 97.2187 111.525 99.8398 111.525 103.073C111.525 106.306 114.138 108.927 117.362 108.927Z",
    fill: "#4FD0A8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.1361,
    cy: 103.225,
    r: 29.1361,
    fill: "#1A2639"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1466 93.2356L38.9653 113.054",
    stroke: "#4FD0A8",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9653 93.3959L19.1466 113.215",
    stroke: "#4FD0A8",
    strokeWidth: 6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNothingStaked);
export default __webpack_public_path__ + "static/media/nothing-staked.29bffbd741faf59de80fb4d020a688f8.svg";
export { ForwardRef as ReactComponent };